import { useAuthStore } from '../stores/auth'

export function setupRouterGuard(router) {
  router.beforeEach((to, from, next) => {
    // H5 页面通常不需要强制登录，但可以根据需要添加认证逻辑
    // 如果需要认证，可以取消下面的注释
    // const auth = useAuthStore()
    // if (!auth.token && to.path !== '/login') {
    //   next('/login')
    // } else {
    //   next()
    // }
    next()
  })
}

